import './thompson/style';
import FormStructure from './thompson/form_structure';

export default FormStructure;